<template>
<div class="chapter">
<div class="inner_page">
<p class="cover"><img alt="" src="iii.png" style="height: 100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a9781847674562_booktitlepage.vue?0cc07b1f